import { ShootingStars } from "@/components/ui/shooting-stars"
import { StarsBackground } from "@/components/ui/stars-background"

export function StarField() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true">
      <StarsBackground />
      <ShootingStars />
    </div>
  )
}
